import { Controller } from "@hotwired/stimulus"

// A figure's options on a shelf (release_watch/watches/options/_shelf): one
// row of columns that slides along under a strip of their heads. The strip
// follows the row, the arrows slide it a column at a time, a head slides
// straight to its column, and the count says which options are in view.
export default class extends Controller {
  static targets = [ "track", "heads", "col", "prev", "next", "count", "arrows" ]

  connect() {
    this.sync = this.sync.bind(this)
    this.observer = new ResizeObserver(this.sync)
    this.observer.observe(this.element)
    this.sync()
  }

  disconnect() {
    this.observer.disconnect()
  }

  // How far apart the columns are (a column and the gap after it).
  step() {
    const [ a, b ] = this.colTargets
    return b ? b.offsetLeft - a.offsetLeft : this.trackTarget.clientWidth
  }

  prev() { this.trackTarget.scrollBy({ left: -this.step(), behavior: "smooth" }) }
  next() { this.trackTarget.scrollBy({ left: this.step(), behavior: "smooth" }) }

  jump(event) {
    const col = this.colTargets[+event.currentTarget.dataset.index]
    this.trackTarget.scrollTo({ left: col.offsetLeft - this.colTargets[0].offsetLeft, behavior: "smooth" })
  }

  // Swiping sideways over the heads slides the shelf too.
  wheel(event) {
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return
    this.trackTarget.scrollLeft += event.deltaX
    event.preventDefault()
  }

  sync() {
    const track = this.trackTarget
    if (!track.clientWidth) return
    this.headsTarget.scrollLeft = track.scrollLeft
    const max = track.scrollWidth - track.clientWidth
    const atStart = track.scrollLeft <= 2
    const atEnd = track.scrollLeft >= max - 2
    this.prevTarget.disabled = atStart
    this.nextTarget.disabled = atEnd
    this.arrowsTarget.hidden = max <= 2
    this.element.classList.toggle("has-more-left", !atStart)
    this.element.classList.toggle("has-more-right", !atEnd)

    const total = this.colTargets.length
    const step = this.step()
    const whole = Math.max(1, Math.floor((track.clientWidth + 20) / step))
    const first = atEnd ? total - whole + 1 : Math.round(track.scrollLeft / step) + 1
    const last = atEnd ? total : Math.min(total, first + whole - 1)
    this.countTarget.textContent = first === last ? `Option ${first} of ${total}` : `Options ${first}–${last} of ${total}`
  }
}
